export enum StoreActions {

    // BURGER BUILDER
    ADD_INGREDIENT = 'ADD INGREDIENT',
    REMOVE_INGREDIENT = 'REMOVE INGREDIENT',
    INITIALISE_BURGER = 'INITIALISE BURGER',

    BURGER_ORDER_INITIATED = 'BURGER ORDER INITIATED',
    // ORDER BURGER
    ORDER_BURGER = 'ORDER BURGER',
    BURGER_ORDER_COMPLETED = 'BURGER_ORDER_COMPLETED',

    // DELETE BURGER
    DELETE_BURGER_STARTED = 'DELETE BURGER STARTED',
    DELETE_BURGER = 'DELETE BURGER',
    DELETE_BURGER_COMPLETED = 'DELETE BURGER COMPLETED',

    // MY ORDERS
    ORDERS_LOADING = 'ORDERS LOADING',
    ORDERS_LOADED = 'ORDERS LOADED',
    SAVE_ORDERS = 'SAVE ORDERS',

    // DRAFT ORDER
    CREATE_DRAFT_ORDER = 'CREATE DRAFT ORDER',
    CLEAR_DRAFT_ORDER = 'CLEAR DRAFT ORDER',

    CLEAR_ORDER_STORE = 'CLEAR ORDER STORE',

    // LOGIN
    LOGIN = 'LOGIN',
    LOGIN_STARTED = 'LOGIN STARTED',
    LOGIN_COMPLETED = 'LOGIN_COMPLETED',

    // SIGN UP
    SIGN_UP_STARTED = 'SIGN UP STARTED',
    SIGN_UP_COMPLETED = 'SIGN UP COMPLETED',

    // ID TOKEN EXCHANGE
    ID_TOKEN_LOADING = 'ID TOKEN LOADING',
    EXCHANGE_ID_TOKEN = 'EXCHANGE ID TOKEN',
    ID_TOKEN_EXCHANGE_COMPLETED = 'ID TOKEN EXCHANGE COMPLETED',

    // PASSWORD RESET
    RESET_PASSWORD_STARTED = 'RESET PASSWORD STARTED',
    RESET_PASSWORD_COMPLETED = 'RESET PASSWORD COMPLETED',

    // LOGOUT
    LOGOUT = 'LOGOUT'
}